import { Hotkeys } from '../types/HotkeyCommand';

export function convertDelKeyToBackspaceForMacProcessor(keys: Hotkeys): Hotkeys {
    if (Array.isArray(keys)) {
        if (keys.includes('del')) {
            return keys.concat('backspace');
        }
    } else if (keys === 'del') {
        return ['del', 'backspace'];
    }

    return keys;
}

export function convertCtrlToCmdForMacProcessor(keys: Hotkeys): Hotkeys {
    if (Array.isArray(keys)) {
        return keys.map(convertCtrlToCmdForMac);
    } else {
        return convertCtrlToCmdForMac(keys);
    }
}

function convertCtrlToCmdForMac(key: string): string {
    return key.replace(/\bctrl\b/, 'command');
}

export default [convertDelKeyToBackspaceForMacProcessor, convertCtrlToCmdForMacProcessor];
